export default __webpack_public_path__ + "static/media/bg1.075eca75.jpg";